import { Reservation } from '@core/models';

export function getReservationFullName<T>(reservation: Reservation<T>) {
  return `${reservation.firstName} ${reservation.lastName}`;
}
